import React, { useState, useEffect } from 'react';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/PublicHeader';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import FlightTabs from './FlightTabs';
import moment from 'moment';
const FlightBookings = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [lists, setLists] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const GetData = async (pageNumber) => {
        setPageLoading(true);
        const res = await apiService.post(`${config.GETUSERFLIGHTBOOKINGS}/${user?.id}`, pageSize, pageNumber);
        console.log(res);
        setLists(res);
        setPageLoading(false);
    };
    const handleConfirm = async (e, FlightBookingId) => {
        setPageLoading(true);
        const res = await apiService.post(`${config.CONFIRMHOLDFLIGHTBOOKING}/${FlightBookingId}`, pageSize, pageNumber);
        console.log(res);
        navigate("/flight/booking/" + FlightBookingId)
    };
    useEffect(() => {
        if (user && !loading) {
            GetData(pageNumber);
        }
    }, [user, loading]);
    if (loading) return <p>Loading...</p>;
    if (!user) {navigate("/")};
    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="p-2">
                                    <FlightTabs pageName="FLIGHTBOOKING" />
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card p-2">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="bg-soft-success bg-gradient">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Booking No</th>
                                                    <th>Journey</th>
                                                    <th>Departure</th>
                                                    <th>Traveller</th>
                                                    <th>Booking</th>
                                                    <th>Payment</th>
                                                    <th>Amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            {pageLoading === true ?
                                                <tbody className="list form-check-all text-center">
                                                    <tr>
                                                        <td colSpan={9}>
                                                            <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
                                                            Loading, Please wait...
                                                        </td>
                                                    </tr>
                                                </tbody> :
                                                <tbody className="list form-check-all">
                                                    {lists.length > 0 && lists.map((v, index) =>
                                                        <tr key={v.flightBookingId}>
                                                            <td>{index + 1}</td>
                                                            <td>{v.bookingNo}<br />PNR : {v.pnr}</td>
                                                            <td>{v.journeyType}</td>
                                                            <td>{v.locationFrom} - {v.locationTo}<br />
                                                                Departure Date : {moment(v.departureDate).format("DD MMM YY")}</td>
                                                            <td>{v.travellerName}</td>
                                                            <td>{v.bookingStatus === "CONFIRMED" ? <span className='badge bg-success'>CONFIRMED</span> : <span className='badge bg-warning'>{v.bookingStatus}</span>}</td>
                                                            <td>{v.paymentStatus === "SUCCESS" ? <span className='badge bg-success'>SUCCESS</span> : <span className='badge bg-warning'>{v.paymentStatus}</span>}</td>
                                                            <td>{v.totalPrice} INR</td>
                                                            <td>
                                                                <ul className="list-inline hstack gap-2 mb-0">
                                                                    {v.bookingStatus === "HOLD" ?
                                                                        <li className="list-inline-item">
                                                                            <button onClick={(e) => handleConfirm(e, v.flightBookingId)} className='btn btn-sm btn-secondary'>CONFIRM</button>
                                                                        </li> :
                                                                        ""
                                                                    }
                                                                    <li className="list-inline-item">
                                                                        <Link to={"/flight/booking/" + v.flightBookingId} className='btn btn-sm btn-primary'>VIEW</Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlightBookings;
